import * as React from 'react';
import { useSnackbar, ProviderContext } from 'notistack';

export type WithSnackbarProps = ProviderContext;

export function withSnackbar<P extends WithSnackbarProps>(
  Component: React.ComponentType<P>,
): React.ComponentType<Omit<P, keyof WithSnackbarProps>> {
  function WithSnackbarHoc(props: Omit<P, keyof WithSnackbarProps>) {
    const snackbar = useSnackbar();
    return <Component {...(props as P)} {...snackbar} />;
  }
  WithSnackbarHoc.displayName = `withSnackbar(${Component.displayName || Component.name || 'Component'})`;
  return WithSnackbarHoc;
}
